import {Entity} from 'app/core/main.entity';
import 'reflect-metadata';

export class FormElementVisibility extends Entity {
  field?: string = null;
  value?: string = null;
}
